import Button from "@/common/elements/Button";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Table from "@/common/elements/Table";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
  StyledSubTableContainer,
} from "@/common/styles";
import CustomModal from "../CustomModal";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Form } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

const BailRecordDetailForm = ({ formData, form }) => {
  const [bailDetail, setBailDetail] = useState(null);

  useEffect(() => {
    setBailDetail(() => ({
      ...formData,
      offBondDate: isNonEmptyVariable(formData?.offBondDate)
        ? dayjs(formData?.offBondDate)
        : null,
    }));
  }, [formData]);

  useEffect(() => {
    form.setFieldsValue(bailDetail);
  }, [bailDetail]);
  return (
    <>
      <StyledSectionHeading>
        <span>Bail Information</span>
      </StyledSectionHeading>
      <Form form={form} initialValues={bailDetail}>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={5}>
            <FormItem label="Bond Type" name="bailTypeID">
              <Select
                options={getOptionsFromRefList("BondType", false, false, true)}
                placeholder="Bond Type"
                showSearch={false}
                variant="outlined"
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={4}>
            <FormItem label="Amount" name="bailAmount">
              <TextField type="number" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={4}>
            <FormItem label="Court #" name="courtNumber">
              <TextField type="number" />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={5}>
            <FormItem label="Off Bond Date" name="offBondDate">
              <CommonDatePicker
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY"
                showTime={false}
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={5}>
            <FormItem
              name="requiredPaymentTypeID"
              label="Required Payment Type"
              layout="vertical"
            >
              <Select
                options={getOptionsFromRefList(
                  "Payment_Type",
                  false,
                  false,
                  true
                )}
                placeholder="Payment Type"
                showSearch={false}
                variant="outlined"
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={5}>
            <FormItem label="Citation Type" name="citationType">
              <Select />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={24}>
            <FormItem label="Comments" name="comments">
              <TextField inputType="textarea" />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>

      <StyledSectionHeading>
        <span>Charges for this bail</span>
      </StyledSectionHeading>

      <StyledSubTableContainer>
        <Table
          headers={[
            { key: "id", text: "#" },
            { key: "charge", text: "Charge" },
          ]}
          data={[]}
          variant="outlined"
        />
      </StyledSubTableContainer>

      <StyledSectionHeading marginTop="25px">
        <span>Bail Administrative Information</span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={4}>
          <FormItem label="ID">
            <TextField />
          </FormItem>
        </StyledGridCol>

        <StyledGridCol lg={6}>
          <FormItem label="Date Entered">
            <TextField />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem label="Time Entered">
            <TextField />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem label="User">
            <TextField />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </>
  );
};
export default BailRecordDetailForm;
